<template>
    <el-dialog :title="Object.keys(info).length === 0 ? '新增活动' : '修改活动'" :visible.sync="dialogVisible" width="700px" :before-close="handleClose">
        <el-form ref="form" size="small" :rules="rules" :model="form" label-width="100px">
            <el-form-item label="活动类型" prop="active_type">
                <el-select v-model="form.active_type" placeholder="请选择活动类型" :disabled="Object.keys(info).length > 0" @change="activeTypeChange" style="width: 100%">
                    <el-option v-for="item of rule_list" :key="item.active_type" :label="item.schema_name_title" :value="item.active_type"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="平台" prop="type_name" v-if="active_info.type_name">
                <el-select v-model="form.type_name" :placeholder="active_info.type_name.placeholder" :disabled="Object.keys(info).length > 0" style="width: 100%">
                    <el-option v-for="item of active_info.type_name.options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="活动名称" prop="active_name">
                <el-input v-model="form.active_name" placeholder="请选择活动名称"></el-input>
            </el-form-item>
            <el-form-item label="活动描述" prop="describe">
                <el-input type="textarea" v-model="form.describe" placeholder="请输入活动描述"></el-input>
            </el-form-item>

            <el-form-item label="活动周期" prop="timetype" v-if="active_info.timetype">
                <el-select v-model="form.timetype" :placeholder="active_info.placeholder" :disabled="Object.keys(info).length > 0" style="width: 100%">
                    <el-option v-for="item of active_info.timetype.options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="活动时间" v-if="active_info.startdate">
                <el-col :span="11">
                    <el-form-item prop="startdate">
                        <el-date-picker type="date" :placeholder="active_info.startdate.placeholder" v-model="form.startdate" style="width: 100%"></el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col class="line" :span="2" style="text-align: center">-</el-col>
                <el-col :span="11">
                    <el-form-item prop="enddate">
                        <el-date-picker type="date" :placeholder="active_info.enddate.placeholder" v-model="form.enddate" style="width: 100%"></el-date-picker>
                    </el-form-item>
                </el-col>
            </el-form-item>
            <el-form-item label="达标数量" prop="amount">
                <el-input v-model="form.amount" placeholder="请输入达标数量" oninput="value=value.replace(/[^\d]/g,'')"></el-input>
            </el-form-item>
            <el-form-item label="奖励积分" prop="point">
                <el-input v-model="form.point" placeholder="请输入奖励积分" oninput="value=value.replace(/[^\d]/g,'')"></el-input>
            </el-form-item>
            <el-form-item label="排序号"  prop="sort">
                <el-input v-model="form.sort" placeholder="请输入排序号" oninput="value=value.replace(/[^\d]/g,'')"></el-input>
            </el-form-item>

            <el-form-item label="活动状态">
                <el-switch v-model="form.status" active-color="#13ce66" active-text="打开" inactive-text="暂停" :active-value="activeValue" :inactive-value="inactiveValue"></el-switch>
            </el-form-item>
            

            <el-form-item class="add_active_footer">
                <el-button @click="handleClose">取消</el-button>
                <el-button type="primary" v-if="Object.keys(info).length === 0" :loading="loading" @click="onSubmit">创建</el-button>
                <el-button type="primary" v-else :loading="loading" @click="onUpdata">更新</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
</template>

<script>
import serverApi from '../../../server/index';
export default {
    props: ['dialogVisible', 'rule_list', 'info'],
    data() {
        return {
            active_info: {},
            form: {
                type_name: '', // follow thirdapp
                sort: '',
                active_type: '',
                active_name: '',
                timetype: '',
                startdate: '',
                enddate: '',
                amount: '',
                point: '',
                describe: "",
                status: 1,
            },
            loading: false,
            rules: {
                active_type: [{ required: true, message: '请选择活动类型', trigger: 'change' }],
                type_name: [{ required: true, message: '请选择平台', trigger: 'change' }],
                active_name: [{ required: true, message: '请输入活动名称', trigger: 'blur' }],
                timetype: [{ required: true, message: '请选择活动周期', trigger: 'change' }],
                startdate: [{ type: 'date', required: true, message: '请选择开始日期', trigger: 'change' }],
                enddate: [{ type: 'date', required: true, message: '请选择结束时间', trigger: 'change' }],
                amount: [{ required: true, message: '请输入达标数量', trigger: 'blur' }],
                point: [{ required: true, message: '请输入奖励积分', trigger: 'blur' }],
                sort: [{ required: true, message: '请输入排序号', trigger: 'blur' }],
                describe: [{ required: true, message: '请输入活动描述', trigger: 'blur' }],
            },
            activeValue: 1,
            inactiveValue: 0,
        };
    },
    methods: {
        activeTypeChange(val) {
            console.log('activeTypeChange val', val);
            this.active_info = this.rule_list.find(ele => ele.active_type === val);
            console.log('activeTypeChange val', val, this.active_info);

            // clear
            this.form.type_name = '';
            this.form.timetype = '';
            this.form.startdate = '';
            this.form.enddate = '';
        },

        onSubmit() {
            this.$refs.form.validate(valid => {
                if (valid) {
                    const params = {
                        schema_name: this.active_info.schema_name,
                    };
                    console.log('this.form', this.form)
                    Object.keys(this.form).forEach(ele => {
                        if (String(this.form[ele]).length > 0) {
                            if (['startdate', 'enddate'].includes(ele)) {
                                params[ele] = this.$moment(this.form[ele]).format('YYYY-MM-DD');
                            } else {
                                params[ele] = this.form[ele];
                            }
                        }
                    });
                    params.amount = Number(params.amount);
                    params.point = Number(params.point);
                    params.sort = Number(params.sort);
                    console.log('params', params);
                    // this.loading = true;

                    serverApi
                        .addActive(params)
                        .then(res => {
                            if (res.data.code === 0) {
                                this.$message({
                                    message: '添加成功',
                                    type: 'success',
                                });
                                this.$emit('closeModal', true);
                            } else {
                                this.$message({
                                    message: res.data.msg || res.data.error,
                                    type: 'error',
                                });
                            }
                        })
                        .catch(e => {
                            this.$message({
                                message: e.data.error || e.data.msg,
                                type: 'error',
                            });
                        })
                        .finally(() => {
                            this.loading = false;
                        });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        onUpdata() {
            this.$refs.form.validate(valid => {
                if (valid) {
                    const params = {
                        schema_name: this.active_info.schema_name,
                    };
                    Object.keys(this.form).forEach(ele => {
                        if (this.form[ele] !== undefined && String(this.form[ele]).length > 0) {
                            if (['startdate', 'enddate'].includes(ele)) {
                                params[ele] = this.$moment(this.form[ele]).format('YYYY-MM-DD');
                            } else {
                                params[ele] = this.form[ele];
                            }
                        }
                    });
                    params.amount = Number(params.amount);
                    params.point = Number(params.point);
                    params.active_id = this.info.active_id;
                    params.sort = Number(params.sort);
                    this.loading = true;
                    console.log('params', params);

                    serverApi
                        .updataActive(params)
                        .then(res => {
                            if (res.data.code === 0) {
                                this.$message({
                                    message: '修改成功',
                                    type: 'success',
                                });
                                this.$emit('closeModal', true);
                            } else {
                                this.$message({
                                    message: res.data.msg || res.data.error,
                                    type: 'error',
                                });
                            }
                        })
                        .catch(e => {
                            this.$message({
                                message: e.data.error || e.data.msg,
                                type: 'error',
                            });
                        })
                        .finally(() => {
                            this.loading = false;
                        });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        handleClose() {
            this.$emit('closeModal', false);
        },
    },
    created() {
        console.log('info', this.info);
        if (Object.keys(this.info).length === 0) return;
        const { type_name, active_type, active_name, timetype, startdate, enddate, amount, point, status, sort, describe } = this.info;
        this.active_info = this.rule_list.find(ele => ele.active_type === active_type);
        this.form = {
            type_name, // follow thirdapp
            sort: sort,
            active_type,
            active_name,
            timetype,
            startdate: '',
            enddate: '',
            amount,
            point,
            status,
            describe,
        };
        if (startdate) {
            this.form.startdate = new Date(startdate);
            this.form.enddate = new Date(enddate);
        }
    },
};
</script>

<style lang="scss">
.add_active_footer {
    margin-top: 30px;
    button {
        width: 200px;
        margin-right: 30px;
        height: 35px;
        &:last-child {
            margin-right: 0;
        }
    }
}
</style>
